package com.essntl.features.proposal.ui.proposalhistory

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.invoice.ui.allinvoice.InvoiceEvent
import com.essntl.features.invoice.ui.allinvoice.InvoiceState
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.ui.proposalhistory.components.ProposalActionButtonsRow
import com.essntl.features.proposal.ui.proposalhistory.components.ProposalBaseInformation
import com.essntl.features.proposal.ui.proposalhistory.components.ProposalInvoices
import com.essntl.features.proposal.ui.proposalhistory.components.ProposalJourneyDetails
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.config.FeatureConfig
import core.config.buildFlavor

@Composable
fun ProposalOverviewScreen(
    state: ProposalOverviewState,
    onNavigation: (ProposalOverviewNavigation) -> Unit,
    invoiceState: InvoiceState,
    onInvoiceEvent: (InvoiceEvent) -> Unit,
    onCopyProposalHistory: (proposal: ProposalModel) -> Unit,
) {
    val isLoading = remember(state) { state.isLoading }

    val isFailure = remember(state) { state.isFailure }

    Column(
        modifier = Modifier
            .fillMaxSize(),
    ) {

        state.getProposal.data?.let { proposal ->
            ProposalActionButtonsRow(
                state = state,
                proposal = proposal,
                onCopyProposalHistory = onCopyProposalHistory,
                onEditProposal = {
                    onNavigation(ProposalOverviewNavigation.EditProposal(it))
                },
            )
        }

        Spacer(modifier = Modifier.height(1f.spacing))

        LazyColumn(
            verticalArrangement = Arrangement.spacedBy(1f.spacing),
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .clip(
                    RoundedCornerShape(
                        topStart = 24.dp,
                        topEnd = 24.dp,
                    ),
                ),
        ) {
            if (
                isLoading ||
                isFailure ||
                state.getProposal.data == null
            ) {
                item {
                    Box(
                        contentAlignment = Alignment.Center,
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(200.dp)
                            .padding(2.5f.spacing)
                            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
                    ) {
                        if (isLoading)
                            EsSpinner()
                        else
                            Text(
                                text = "Something goes wrong!",
                                color = MaterialTheme.esColorScheme.textSecondary,
                                style = MaterialTheme.esTypography.p1Medium16,
                            )
                    }
                }
            } else {
                state.getProposal.data?.let { proposal ->
                    if (FeatureConfig.hasQuickBooks)
                        item {
                            ProposalInvoices(
                                state = invoiceState,
                                onInvoiceEvent = onInvoiceEvent,
                                proposalId = proposal.id,
                                isAdmin = state.getCurrentProfile.data?.role == ProfileModel.Role.Admin || state.getCurrentProfile.data?.role == ProfileModel.Role.Owner,
                                onInvoiceClick = { invoiceId ->
                                    onNavigation(
                                        ProposalOverviewNavigation.EditInvoice(
                                            proposalId = proposal.id,
                                            invoiceId = invoiceId,
                                        ),
                                    )
                                },
                                onAddInvoice = {
                                    onNavigation(
                                        ProposalOverviewNavigation.AddInvoice(
                                            proposalId = proposal.id,
                                        ),
                                    )
                                },
                            )
                        }

                    item {
                        ProposalBaseInformation(
                            state = state,
                            proposal = proposal,
                        )
                    }

                    item {
                        ProposalJourneyDetails(
                            proposal = proposal,
                            proposalServiceList = state.toUiState(),
                        )
                    }
                }
            }
        }
    }
}
